import {PageView} from "./PageView.js";
import {UserProfileLayout} from "../components/layout/UserProfileLayout.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {
    addPassword,
    addPhoneAuthCompleted,
    addPhoneNumber,
    addUserName,
    collectGtm,
    getPhoneAuthCompleted,
    getUserId,
    getUserName,
    isGuestUser,
    isSnsSignUp
} from "../store.js";
import {PasswordInput} from "../components/input/PasswordInput.js";
import {NameInput} from "../components/input/NameInput.js";
import {Header} from "../components/Header.js";
import {TermPopup} from "../components/popup/TermPopup.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import PhoneAuth from "../components/input-group/PhoneAuth.js";
import {PhoneNumberInput} from "../components/input/PhoneNumberInput.js";

export class UserProfileView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        const userId = getUserId();
        const region = window._CLIENT_REGION || 'KR'

        this.$props.UserProfileLayout = new UserProfileLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            userId,
            nextButton: {
                id: 'userProfileSubmit',
                text: this.getNextButtonText(),
                nextPageFunc: this.nextPage.bind(this),
                disabled: Often.isGlobal() ? false : region === 'KR',
            }
        });
    }

    renderComponents() {
        if(!this.$props.UserProfileLayout) {
            return;
        }
        // 패스워드 입력 태그 추가
        new Header(this.$props.UserProfileLayout.getHeaderLayer(), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });

        // 이름 입력 태그 추가
        this.$props.NameInput = new NameInput(this.$props.UserProfileLayout.getUserNameLayer(), {
            isLast: Often.isGlobal(),
            addClassName: this.getCommonJoinInputClassName(),
            submit : this.nextPage.bind(this),
            value : isSnsSignUp() ? getUserName() : ""
        });

        this.$props.PasswordInput = !isSnsSignUp() ? new PasswordInput(this.$props.UserProfileLayout.getPasswordLayer(), {
            allowBlank: false,
            addClassName: this.getCommonJoinInputClassName()
        }) : null;

        if (!Often.isGlobal()) {
            const region = window._CLIENT_REGION || 'KR'
            if (region === 'KR') {
                this.$props.PhoneAuth = PhoneAuth()
                this.$props.PhoneAuth.init({
                    target: this.$props.UserProfileLayout.getPhoneAuthLayer(),
                    renderOption: 'append',
                })
                return
            }

            this.$props.PhoneNumberInput = new PhoneNumberInput(this.$props.UserProfileLayout.getPhoneAuthLayer(), {
                isLast: true,
                addClassName: this.getCommonJoinInputClassName(),
                submit: this.nextPage.bind(this),
            })
        }
    }

    getSectionId() {
        return `profileInputSection`;
    }

    getCommonJoinInputClassName() {
        return `js-join-input`
    }
    async nextPage() {
        const $profileInputSection = $(`#${this.getSectionId()}`)
        const $profileInputs = $profileInputSection.find(`.${this.getCommonJoinInputClassName()}`)
        if (!InputValidator.inputsValidate($profileInputs)) {
            return
        }

        const region = window._CLIENT_REGION || 'KR'
        if (!Often.isGlobal() && region === 'KR') {
            if (!getPhoneAuthCompleted()) {
                await this.verifyAuthCode()
            }

            // note: verifyAuthCode()의 결과로 phoneAuthCompleted 값이 변경되었을 수 있으므로 조건에 반드시 추가
            if (!getPhoneAuthCompleted()) {
                this.$props.PhoneAuth.validatePhoneAuthInputs()
                return
            }
        }

        this.addUserInfo()
        window.SIGN_UP_ID = getUserId(); // welcomeStep 에서 사용하기 위함

        if(!Often.isGlobal()) {
            new TermPopup($profileInputSection,{
                isAppend : true,
            })
            return
        }

        if(isGuestUser()) {
            Mutil.mlog("게스트 유저는 해당 페이지로 올 수 없습니다.");
            return;
        }

        new LoadingPopup(this.$props.UserProfileLayout.getMainArticle(), {
            isAppend: true,
            loadingText : i18next.t(common.wait),
            isNoLoadingText : true
        });

        SignUpViewChanger.loadCompanyInviteView();
    }

    addUserInfo() {
        addUserName(this.$props.NameInput.getInputValue());

        if (this.$props?.PasswordInput !== null) {
            addPassword(this.$props.PasswordInput.getInputValue());
        }

        addPhoneNumber($('#phoneNumberInput').val())
    }

    async verifyAuthCode() {
        const $target = this.$props.UserProfileLayout.getPhoneAuthLayer()
        const $authCodeInput = $target.find('#authCodeInput')
        const $authCountMessage = $target.find('.js-counter-message')

        // confirm auth code
        const authResult = await this.$props.PhoneAuth.verifyAuthCode()
        if (!authResult) {
            $authCodeInput.closest('.js-interactive-form-wrap').addClass('status-error')
            $authCountMessage.text(i18next.t(main.alert.verificationNotMatch))
            return
        }

        $target.find('#phoneNumberInput').attr('disabled', true)
        $target.find('.js-phone-auth-button').attr('disabled', true)
        $authCodeInput.attr('disabled', true)
        $target.find('.js-counter-wrap').hide()

        addPhoneAuthCompleted(true)
        this.$props.PhoneAuth.stopCounter()
    }
}

